export interface AuthStorePersistSlice {
  activeTeamId: string | null
  persistedUserId: string | null
}

export interface AuthStoreMergeCurrentState {
  user: { id?: string } | null
  activeTeamId: string | null
}

/** Slice écrit dans localStorage (auth-store). */
export function partializeAuthStorePersist(state: {
  activeTeamId: string | null
  user: { id?: string } | null
}): AuthStorePersistSlice {
  return {
    activeTeamId: state.activeTeamId,
    persistedUserId: state.user?.id ?? null,
  }
}

/**
 * Fusion rehydrate Zustand : ignore activeTeamId si l'utilisateur a changé
 * (ex. admin enterprise ↔ freelance sur le même navigateur).
 */
export function mergePersistedAuthStoreState<T extends AuthStoreMergeCurrentState>(
  persistedState: Partial<AuthStorePersistSlice> | undefined,
  currentState: T
): T {
  const persisted = persistedState ?? {}
  const persistedUserId = persisted.persistedUserId ?? null
  const currentUserId = currentState.user?.id ?? null
  const sameUser =
    !persistedUserId || !currentUserId || persistedUserId === currentUserId

  return {
    ...currentState,
    activeTeamId: sameUser
      ? (persisted.activeTeamId ?? currentState.activeTeamId)
      : null,
  }
}
